<template>
  <div class="market-modal">
    <sweet-modal ref="marketModal" overlay-theme="dark" @close="onClose" :blocking="true" >
      <transition name="fade">
        <div v-if="vModal">
          <div class="title-modal">앱 마켓</div>
          <div class="content-modal">
            <iframe id="market-modal" :src="marketPath"></iframe>
          </div>
        </div>
      </transition>
    </sweet-modal>
  </div>
</template>

<script>
  import { SweetModal } from 'sweet-modal-vue'
  export default {
    name: "ModalAppMarket",
    components: {
      SweetModal
    },
    created() {
      /*window.addEventListener('message', e => {
        if(e.data.close) {
          this.$refs.marketModal.close();
        }
      });*/
      this.$root.$on('appMarket', (res) => {
        let admin = this.$store.getters.admin;
        this.marketPath = `https://platformfy.com/app_market?i=${admin.id}&tn=${admin.token}&s=${this.$store.getters.masterService.service_id}&parent=office`;
        //this.marketPath = `http://localhost:8081/app_market?i=${admin.id}&tn=${admin.token}&s=${this.$store.getters.masterService.id}&parent=office`;
        //this.marketPath = `https://pfa.platformfy.com/app_market?i=${admin.id}&tn=${admin.token}&s=${this.$store.getters.masterService.id}&parent=office`;
        if(res) {
          if(res.pack) {
            this.marketPath += `&pack=${res.pack}`;
          } else if(res.plugin) {
            this.marketPath += `&plugin=${res.plugin}`;
          } else if(res.detail) {
            this.marketPath += `&detail=${res.detail}`;
          } else if(res.category) {
            this.marketPath += `&category=${res.category}`;
          } else if(res.order_list) {
            this.marketPath += '&order_list=true';
          }
        }
        /*this.vModal = true;
        this.$refs.marketModal.open();*/
        let width = 1231;
        let height = 760;
        /*if(window.innerHeight < height) {
          height = window.innerHeight - 80;
        }
        if(window.innerWidth < width) {
          width = window.innerWidth - 200;
        }*/
        this.popupMarket = window.open(this.marketPath, 'appMarket', `width=${width}, height=${height}, top=0, left=0, menubar=no, toolbar=no, titlebar=no, location=no`);
        this.addMessageEvent();
      });
    },
    mounted() {
    },
    data() {
      return {
        vModal: false,
        marketPath: 'https://platformfy.com/app_market',
        popupMarket: undefined,
      }
    },
    methods: {
      addMessageEvent() {
        window.addEventListener('message', this.onMessageMarket);
      },
      removeMessageEvent() {
        window.removeEventListener('message', this.onMessageMarket);
      },
      onMessageMarket(e) {
        if(e.data.close) {
          this.popupMarket.close();
          this.onClose();
          this.removeMessageEvent();
        }
        if(e.data.inquiry) {
          let query = '';
          if(e.data.inquiryId) {
            query = `?id=${e.data.inquiryId}`;
          }
          else if(e.data.cat) {
            query = `?cat=${e.data.cat}`;
          }
          this.$router.push(this.getPath('launchpack/inquiry/customer/create'+query));
        } else if(e.data.adminRedirect) {
          this.clickFeature({key: e.data.adminRedirect});
        } else if(e.data.addPlugin) {
          let param = `add_plugin=${e.data.addPlugin}`;

          // 지정 경로로 이동시킬 플러그인
          const plugin_move_page = ['point_coupon'];
          if(plugin_move_page.indexOf(e.data.addPlugin)>-1) {
            param = 'front_path=my_point';
          }
          window.open(`/developers/ui/builder?${param}`, '_blank');

        } else if(e.data.planOpen) {
          this.$root.$emit('planChangeModal');
        }
      },
      async clickFeature(item) {
        const featureLink = [
          {
            path: 'service/setting',
            keys: ['virtual_account', 'naverpay', 'kakaopay', 'mobile_payment', 'account_transfer', 'pg_card',]
          },
          {
            path: 'service/account',
            keys: ['sns_signin']
          },
          {
            path: 'partner',
            keys: ['partner_video']
          },
          {
            path: 'product',
            keys: ['recent_product', 'product_image_upload', 'product_video', 'product_priority', 'sns_inquiry',
              'product_file_upload', 'time_sale']
          },
          {
            path: 'exhibition_partner_product',
            keys: ['partner_product_exhibition']
          },
          {
            path: 'exhibition_partner',
            keys: ['partner_exhibition']
          },
          {
            path: 'order',
            keys: ['order_detail_print']
          },
          {
            path: 'service/account?menu=verify',
            keys: ['nice_identity_verify', 'identity_verify', 'age_verify']
          },
          {
            path: 'filter',
            keys: ['category_filterset']
          },
          {
            path: 'partner/approval/all',
            keys: ['partner_approval']
          },
          {
            path: 'supervisor',
            keys: ['supervisor']
          },
          {
            path: 'service/account?menu=channel_io',
            keys: ['channel']
          },
          {
            path: 'point/setting',
            keys: ['point_coupon']
          },
          {
            path: 'push',
            keys: ['app_notification']
          },
          {
            path: 'product/evaluation',
            keys: ['product_review_rate']
          },
          {
            path: 'user/param?guide=true',
            keys: ['user_param']
          },
          {
            path: 'partner/param?guide=true',
            keys: ['partner_param']
          },
          {
            path: 'product/param?guide=true',
            keys: ['product_param']
          },
          {
            path: 'product/grade',
            keys: ['partner_grade']
          },
          {
            path: 'guide',
            keys: ['guide']
          },
          {
            path: 'partner/inquiry/new',
            keys: ['partner_inquiry']
          },
          {
            path: 'popup',
            keys: ['popup']
          },
          {
            path: 'product/approval/new',
            keys: ['product_approval']
          },
          {
            path: 'board',
            keys: ['board']
          },
          {
            path: 'user/grade',
            keys: ['user_grade']
          },
          {
            path: 'service/info',
            keys: ['domain']
          }
        ];
        let feature = featureLink.find(i => i.keys.indexOf(item.key) > -1);
        if(feature) {
          let path = feature.path;
          if(feature.path === 'order') {
            let pack = this.serviceInfo.package;
            let res = await this.$axios.get(this.getUrl(`${pack}/order?cur_page=1&page_length=1`));
            if(res.data.data.length>0) {
              if(pack === 'delivery') {
                path = `delivery/order/detail?id=${res.data.data[0].id}`;
              } else {
                path = `${pack}/order_detail?id=${res.data.data[0].id}`;
              }
            } else {
              if(pack === 'delivery') {
                path = 'delivery/order_list_pay_all';
              } else {
                path = `${pack}/order_list_all`;
              }
            }
          }
          this.routerPush(`/office/admin/${path}`);
        }
      },
      async onClose() {
        this.vModal=false;
        let res = await this.$axios.get('public/service/packages');
        this.$store.commit('setPackages', res.data);

        res = await this.$axios.get('public/service/setting');
        this.$store.commit('setServiceSetting', res.data);
        this.$store.commit('setGuide', res.data.new_package);
        this.$store.commit('setInternalPlugin', res.data.internal_plugin);

        res = await this.$axios.get('admin/v1/order/setting');
        this.$store.commit('setOrderSetting', res.data);

        this.$root.$emit('menus');
      }
    },
    watch: {
      vModal(n) {
        if(!n) {
          this.$store.commit('setOpenAppMarket', false);
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .title-modal
    background-color #242428
    font-size 16px
    color white
    padding 16px 24px
  .content-modal
    background-color white
  iframe
    width 100%
    border 0
    height calc(90vh - 62px)
</style>
<style lang="stylus">
  .market-modal
    .sweet-modal.is-alert .sweet-content
      padding 0 !important
      text-align left
    .sweet-modal .sweet-box-actions .sweet-action-close
      color white
    .sweet-modal .sweet-box-actions
      top 6px
    .sweet-modal
      min-width 1200px
      max-width 1200px
      border-radius 8px
      max-height 90vh
      background-color transparent
    .sweet-content-content
      .content
        height calc(90vh - 62px)
</style>
